<template>
    <div>

        <template v-if="contractorDetail">
            <!--<Row>{{contractorDetail.name}} (<span :style="{color: getColor(contractorDetail.status)}">{{contractorDetail.status}}</span>)</Row>-->
            <Row :gutter="10" style="font-size: 15px">
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">Name</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.name}} - {{contractorDetail.contractorCode}}</Col>
                        <Col :md="8" style="color: #444444">Mobile No.</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.mobile}}</Col>
                        <Col :md="8" style="color: #444444">Email</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.email}}</Col>
                        <Col :md="8" style="color: #444444">Type</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.type?contractType[contractorDetail.type]:'-'}}</Col>
                        <Col :md="8" style="color: #444444">Address</Col><Col span="1">:</Col>
                        <Col :md="12">{{getAddressString(contractorDetail.contractorAddress)}}</Col>
                    </Row>
                </Col>
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">GST</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.gstin?contractorDetail.gstin:'-'}}</Col>
                        <Col :md="8" style="color: #444444">PAN</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.pan?contractorDetail.pan:'-'}}</Col>
                        <Col :md="8" style="color: #444444">City</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.city?contractorDetail.city:'-'}}</Col>
                        <Col :md="8" style="color: #444444">Total Tempos</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.tempos.length}}</Col>
                        <Col :md="8" style="color: #444444">Total Drivers</Col><Col span="1">:</Col>
                        <Col :md="12">{{contractorDetail.drivers.length}}</Col>
                    </Row>
                </Col>
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">Pickup Orders</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Total Bill Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Total Paid Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Due Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Status</Col><Col span="1">:</Col>
                      <Col :md="12">
                        <i-switch v-model="contractorDetail.status" @on-change="onChangeStatus(contractorDetail)" :style="contractorDetail.status?'background: green':'background: red'"/>
                        <!-- <Tag :color="contractorDetail.status?'success':'red'">{{contractorDetail.status?'Active':'InActive'}}</Tag> -->
                      </Col>
                    </Row>
                </Col>
            </Row>
        </template>


        <Tabs v-model="screen" type="card" style="margin-top: 50px">
            <TabPane label="Details" name="details"></TabPane>
            <TabPane label="Tempo Orders" name="tempo_orders"></TabPane>
        </Tabs>

        <div v-show="screen === 'details'">
            <Spin fix size="small" v-if="!contractorDetail"></Spin>
            <Row :gutter="10">
                <Col :md="12">
                    <Button @click.stop="onAddTempo()">Add Tempo</Button>
                    <Button v-if="isAdmin" @click="exportContractorTempos" style="margin-left: 10px">Export CSV</Button>
                    <hot-table :settings="tempos_hotSettings" ref="tempos_hotTableComponent" style="margin: 20px 0 0 0">
                        <hot-column v-for="(colset, index) in tempos_columns" :settings="colset" :key="index">
                        </hot-column>
                    </hot-table>
                </Col>
                <Col :md="12">
                    <Button @click.stop="onAddDriver()">Add Driver</Button>
                    <Button v-if="isAdmin" @click="exportContractorDrivers" style="margin-left: 10px">Export CSV</Button>
                    <hot-table :settings="drivers_hotSettings" ref="drivers_hotTableComponent" style="margin: 20px 0 0 0">
                        <hot-column v-for="(colset, index) in drivers_columns" :settings="colset" :key="index">
                        </hot-column>
                    </hot-table>
                </Col>
            </Row>
        </div>

        <div v-show="screen === 'tempo_orders'">
            <Spin fix size="small" v-if="!this.$route.params.id"></Spin>
            <Row>
                <Col :md="8">
                    <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                                format="dd/MM/yyyy" class="filterInput" @on-change="onChangeDate"></DatePicker>
                </Col>
                <Col :md="4">
                  <Select v-model="selectedTempoOrderStatus" placeholder="Status" clearable>
                    <Option v-for="type in ['Active', 'Completed']" :value="type" :label="type" :key="type">
                      <div class="ivu-select-item-div"> {{type}}</div>
                    </Option>
                  </Select>
                </Col>
                <Col :md="4">
                  <Button v-if="isAdmin" @click="exportContractorDetailTempoOrders" style="margin-left: 10px">Export CSV</Button>
                </Col>
                <Input @on-keydown="debounceInput" id="search-field" placeholder="Search by Tempo number, order no, driver etc" style="width: 300px; float: right;"/>
            </Row>

            <hot-table :settings="tempoOrders_hotSettings" ref="tempoOrders_hotTableComponent" style="margin: 20px 0 0 0">
                <hot-column v-for="(colset, index) in tempoOrders_columns" :settings="colset" :key="index">
                </hot-column>
            </hot-table>
        </div>

      <tempo ref="tempo-comp"></tempo>
      <driver ref="driver-comp" isLoadedIn="contractors"></driver>

    </div>
</template>

<script>
    import { HotTable, HotColumn } from '@handsontable/vue'
    import Handsontable from 'handsontable'
    import {GET_CONTRACTOR_DETAIL} from "../../graphql/queries/contractor"
    import {
      SUBSCRIBE_CONTRACTOR_DETAIL,
      SUBSCRIBE_TEMPO_ORDERS_BY_CONTRACTOR_ID
    } from "../../graphql/subscription/contractor"
    import moment from 'moment'
    import {Constants, convertArrToObj, TempoTypes} from '../../Constants/Constant'
    import {dateOptions, generateHotSettings, nestedHeaders} from "../ExcelFormattedOrders/Settings"
    import {calculateTotalWeightOfOrders} from "../ExcelTruckOrders/Settings"
    import _ from 'lodash'
    import {actionRenderer, contractType, tempoOrderStatusRenderer} from "./RendererFunctions";
    import {getAddressString} from "../ExcelFormattedOrders/RendererFunctions";
    import Tempo from "../Settings/Tempo";
    import Driver from "../Settings/Driver";
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";

    export default {
        name: "ContractorDetail",
        components: {Driver, Tempo, HotTable, HotColumn },
        apollo: {
            $subscribe: {
                tempoOrders: {
                    query: SUBSCRIBE_TEMPO_ORDERS_BY_CONTRACTOR_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            contractorId: this.$route.params.id,
                            startDate: this.startDate,
                            endDate: this.endDate,
                            searchFilter: '%' + this.globalSearch + '%'
                        }
                    },
                    result ({ data }) {
                        this.tempoOrders = data.tempoOrders
                        this.prepareSheetDataForTempoOrders(data.tempoOrders)
                    },
                },
                contractorDetail: {
                    query: SUBSCRIBE_CONTRACTOR_DETAIL,
                    skip () {return !this.$route.params.id},
                    variables() {
                      return {
                        contractorId: this.$route.params.id
                      }
                    },
                    result ({ data, loading }) {
                      if (!loading) {
                        this.contractorDetail = data.contractorDetail[0]
                        this.prepareSheetDataForTempos(data.contractorDetail[0].tempos)
                        this.prepareSheetDataForDrivers(data.contractorDetail[0].drivers)
                        this.tempos = data.contractorDetail[0].tempos;
                        this.drivers = data.contractorDetail[0].drivers;
                      }
                    }
                }
            }
        },
        data: function () {
            return{
                Constants: Constants,
                screen: 'details',
                contractorDetail: null,
                tempoOrders: [],
                changeStatusPopup: false,
                loader1: false,
                errMessages: [],
                globalSearch: '',
                filterDate: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                dateOptions: dateOptions,
                tempos_columns: [
                    //table_key_intermediate
                    {
                        title: 'Tempo<br>Number',
                        data: 'tempoNumber',
                        type: 'numeric'
                    },
                    {
                        title: 'Capacity',
                        data: 'capacity',
                    },
                    {
                      title: 'Type',
                      data: 'type',
                    },
                    {
                      title: 'No. of Booking',
                      data: 'totalBooking',
                    },
                    {
                        title: 'Status',
                        data: 'status',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'tempos', 'onEditTempo', 'onDeleteTempo')
                    },
                ],
                tempos_hotSettings: generateHotSettings([145, 100, 100, 100, 100, 100], nestedHeaders.temposTable),
                drivers_columns: [
                    //table_key_intermediate
                    {
                        title: 'Name',
                        data: 'name',
                    },
                    {
                        title: 'Mobile',
                        data: 'mobile',
                    },
                    {
                        title: 'Type',
                        data: 'type',
                    },
                    {
                      title: 'Status',
                      data: 'status',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'drivers', 'onEditDriver', 'onDeleteDriver')
                    }
                ],
                drivers_hotSettings: generateHotSettings([120, 100, 100, 100, 100], nestedHeaders.driversTable),
                tempoOrders_columns: [
                    //table_key_intermediate
                    {
                        title: 'Order<br> date',
                        data: 'date',
                        type: 'date',
                        dateFormat: 'DD/MM/YYYY'
                    },
                    {
                        title:'Status',
                        data: 'status',
                        renderer: tempoOrderStatusRenderer
                    },
                    {
                        title:'Order No',
                        data: 'orderNum',
                        renderer: this.tempoOrderNumRenderer
                    },
                    {
                        title:'Tempo<br> Contractor',
                        data: 'contractor',
                        renderer: this.contractorRenderer
                    },
                    {
                        title:'Tempo<br> Driver',
                        data: 'driver',
                        renderer: this.driverRenderer
                    },
                    {
                        title:'Tempo<br> Number',
                        data: 'tempoPlateNum',
                        renderer: this.tempoPlateNumRenderer
                    },
                    {
                        title:'Load<br> Capacity',
                        data: 'capacity',
                        type: 'numeric'
                    },
                    {
                        title:'Order<br> Assigned',
                        data: 'ordersAssigned',
                        type: 'numeric'
                    },
                    {
                        title:'Weight<br> Delivered',
                        data: 'weightDelivered',
                        type: 'numeric'
                    },
                    {
                        title:'Start<br> KM',
                        data: 'startKm',
                        type: 'numeric'
                    },
                    {
                        title:'End<br> KM',
                        data: 'endKm',
                        type: 'numeric'
                    },
                    {
                        title:'KM Run',
                        data: 'kmRun',
                        type: 'numeric'
                    }
                ],
                tempoOrders_hotSettings: generateHotSettings([90, 100, 145, 120, 100, 100, 125, 110, 110, 88, 75, 95]),
                confirmDialog: false,
                confirmObj: {},
                updateRecord_loader: false,
                contractType: contractType,
                getAddressString: getAddressString,
                tempos: [],
                drivers: [],
                selectedTempoOrderStatus: '',
                TempoTypesJson: convertArrToObj(TempoTypes, 'value', 'label')
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods:{
            debounceInput: _.debounce(function (e) {
                this.globalSearch = e.target.value
            }, 500),
            onChangeDate(evt){
                this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            prepareSheetDataForTempos(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        tempoNumber: curnt.platNo,
                        capacity: curnt.capacity,
                        totalBooking: this.evaluateTotalBookings(curnt.tempoOrders),
                        status: curnt.status?'Active':'Inactive',
                        type: this.TempoTypesJson[curnt.type] || '-',
                        action: '',
                    }
                    mainArr.push(curnt.obj)
                })
                this.tempos_hotSettings.data = mainArr
            },
            prepareSheetDataForDrivers(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        name: curnt.name,
                        mobile: curnt.mobile,
                        status: curnt.status?'Active':'Inactive',
                        type: curnt.driverType === 1?'Tempo Driver':'Truck Driver',
                        action: '',
                    }
                    mainArr.push(curnt.obj)
                })
                this.drivers_hotSettings.data = mainArr
            },
            prepareSheetDataForTempoOrders(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        date: moment(curnt.date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                        status: curnt.endReading?'Completed':'Active',
                        orderNum: curnt.tempoOrderCode,
                        contractor: curnt.contractor.name,
                        driver: curnt.driverDetail.name,
                        tempoPlateNum: curnt.tempo.platNo,
                        capacity: curnt.tempo.capacity,
                        numOfOrders: curnt.orderDetailsArr.length,
                        truckOrders_ewayBillNo: curnt.ewayBillNo,
                        ordersAssigned: curnt.orderDetailsArr.length,
                        weightDelivered: calculateTotalWeightOfOrders(curnt.orderDetailsArr),
                        startKm: curnt.startReading,
                        endKm: curnt.endReading,
                        kmRun: curnt.endReading?(curnt.endReading - curnt.startReading):'-'

                    }
                    mainArr.push(curnt.obj)
                })
                this.tempoOrders_hotSettings.data = mainArr
            },
            tempoOrderNumRenderer(instance, td, row, col, prop, value, cellProperties) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let tempoOrder = this.tempoOrders[pRow]
                td.style.color = 'blue'
                td.classList.add('truck-order-num-txt')
                let self = this
                td.onclick = function() {
                    self.$router.push({ path: '/excel-tempo-orders/'+tempoOrder.id})
                }
            },
            driverRenderer(instance, td, row, col, prop, value, cellProperties) {
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let tempoOrder = this.tempoOrders[pRow]
                td.innerHTML = value + '<br><span style="color: gray">' + tempoOrder?.driverDetail?.mobile + '</span>'
                td.style.verticalAlign = 'middle'
                td.style.textAlign = 'center'
            },
            contractorRenderer(instance, td, row, col, prop, value, cellProperties) {
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let tempoOrder = this.tempoOrders[pRow]
                td.innerHTML = value + '<br><span style="color: gray">' + tempoOrder?.contractorCode + '</span>'
                td.style.verticalAlign = 'middle'
                td.style.textAlign = 'center'
            },
            tempoPlateNumRenderer(instance, td, row, col, prop, value, cellProperties) {
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let tempoOrder = this.tempoOrders[pRow]
                td.innerHTML = value + '<br><span style="color: gray">' + tempoOrder?.tempo?.name + '</span>'
                td.style.verticalAlign = 'middle'
                td.style.textAlign = 'center'
            },
            evaluateTotalBookings(arr){            /* arr -> tempoOrders */
              return arr.reduce((a, b) => (a + b.orderDetailsArr_aggregate.aggregate.count), 0);
            },
            onAddTempo(){
              let row = { id:this.contractorDetail.id, name: this.contractorDetail.name };
              this.$refs['tempo-comp'].onAddTempo(row)
            },
            onEditTempo(row){
              row['Contractor'] = { id:this.contractorDetail.id, name: this.contractorDetail.name };
              this.$refs['tempo-comp'].onEditTempo(row)
            },
            onDeleteTempo(tempoId){
              this.$refs['tempo-comp'].onDeleteTempo(tempoId)
            },
            onAddDriver(){
              let row = { id:this.contractorDetail.id, name: this.contractorDetail.name };
              this.$refs['driver-comp'].onAddDriver(row)
            },
            onEditDriver(row){
              row['Contractor'] = { id:this.contractorDetail.id, name: this.contractorDetail.name };
              this.$refs['driver-comp'].onEditDriver(row)
            },
            onDeleteDriver(driverId){
              this.$refs['driver-comp'].onDeleteDriver(driverId)
            },
            onChangeStatus(row){
              this.$Modal.confirm({
                title: 'Confirmation',
                content: '<p>Are You sure want to change status of Contractor ?</p>',
                loading: true,
                onOk: () => {
                  let obj = {status: row.status}
                  this.updateRecord(row.id, obj, 'contractor', this.$Modal)
                },
                onCancel: () => {
                  row.status = !row.status
                }
              });
            },
            async updateRecord(id, obj, table, callback){
              let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_ORDER_DATA(table),
                variables: { id: id, obj: obj}
              })
              if(response.data){
                this.$Message.success('Contractor updated successfully!')
                callback?.remove();
              }
            },
            exportContractorTempos(){
              let exportPlugin = this.$refs['tempos_hotTableComponent'].hotInstance.getPlugin('exportFile');
              exportPlugin.downloadFile('csv', {
                columnHeaders: true,
                filename: 'ContractorTempos_' + moment().format('DD_MMM_YYYY_HH_mm'),
              });
            },
            exportContractorDrivers(){
                let exportPlugin = this.$refs['drivers_hotTableComponent'].hotInstance.getPlugin('exportFile');
                exportPlugin.downloadFile('csv', {
                  columnHeaders: true,
                  filename: 'ContractorDrivers_' + moment().format('DD_MMM_YYYY_HH_mm'),
                });
             },
            exportContractorDetailTempoOrders(){
              let exportPlugin = this.$refs['tempoOrders_hotTableComponent'].hotInstance.getPlugin('exportFile');
              let str = exportPlugin.exportAsString('csv', {columnHeaders: true});

              let json = {}
              str = str.replace(/<\/?[^>]+(>|$)/g,"") + '\n\n';        //Remove html tags if any
              Object.keys(json).forEach((key) => {
                str = str + key + ',' + json[key] + '\n';
              });

              let blob = new Blob([str], {type: 'text/plain'});
              const a = window.document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = 'clientDetail_Orders_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
          },
        mounted(){
          let tempoTableHeader = document.getElementById('tempo-table-header-action')
        }
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }
    .filterInput{
        width: 80%;
    }
    /deep/ .ivu-date-picker-cells  {
        font-size: 12px !important;
    }
    /deep/ .ivu-picker-panel-sidebar  {
        width:125px !important;
        margin-left:-116px !important;
    }
    /deep/ .handsontable span.colHeader > i{
      position: absolute;
      right: 10px;
      font-size: 14px;
      cursor: pointer;
      color: teal;
    }
    .refresh-icon{
        float: right;
        margin: 9px 16px;
        font-size: 14px;
        cursor: pointer;
    }
</style>
<style>
    .order-num-txt:hover {
        text-decoration: underline;
    }
    .truck-order-num-txt:hover {
        text-decoration: underline;
    }
    .action-edit{
      font-size: 12px;
      color:grey;
      margin-right:15px;
      cursor: pointer;
    }
    .action-delete{
      font-size: 12px;
      color:red;
      cursor: pointer;
    }
    .action-delete:hover{
      color: #FF8C00;
    }
    .action-edit:hover{
      color: #c0c0c0;
    }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
